<template>
    <common-page card-content>
        <query-view ref="table" :config-code="$_configCode"
                    enable-edit
                    enable-import
                    with-custom-actions-head-of-row>
            <template #headOfRow="{row}">
                <b-button-group>
                    <mini-button @btnClick="openCronModal(row)">
                        CRON
                    </mini-button>
                    <mini-button @btnClick="openRequestModal(row)">
                        Request
                    </mini-button>
                </b-button-group>
            </template>
            <template #leftHeader>
                <mini-button :disable="$_notCheckedOne" :loading="triggerLoading" confirm-text="确定要手动执行一次吗？"
                             @btnClick="execute">
                    Run
                </mini-button>
            </template>
        </query-view>

        <template #outer>
            <re-b-modal ref="cronEdit" header="CRON" no-auto-hide enable-popover disable-scrollable @ok="saveCron">
                <cron-light v-model="cron" @error="error=$event"></cron-light>
                <div class="mt-2">Cron Expression: {{ cron }}</div>
                <div v-show="error" class="mt-2 text-danger">Error: {{ error }}</div>
            </re-b-modal>

            <re-b-modal ref="requestConfig" header="Request" no-auto-hide
                        enable-popover disable-scrollable large
                        @hide="clearRequest"
                        @ok="saveRequestConfig">
                <div class="w-100 d-flex flex-row">
                    <btn-select :options="requestMethods" :value.sync="request.method"></btn-select>
                    <mini-input type="input" :value.sync="request.url" class="ml-1 flex-grow-1"
                                without-label></mini-input>
                </div>
                <b-spinner small v-if="configurationLoading"></b-spinner>
                <div v-if="pickedConfig" class="w-100 d-flex flex-row mt-1">
                    <b-button variant="light">Filter</b-button>
                    <qg-filter-builder class="ml-1 flex-grow-1" :config="pickedConfig"
                                       :initForm="listToMap(request.body.where)"
                                       show-invisible
                                       @change="request.body.where=mapToList($event)"/>
                </div>
                <template #footer>
                    <b-button variant="outline-secondary" @click="$refs.entityPick.showModal()">Pick</b-button>
                </template>
            </re-b-modal>
            <qg-entity-pick ref="entityPick" config-code="jsc" :filter="jscFilter"
                            @selected="jscRowSelect"></qg-entity-pick>
        </template>
    </common-page>
</template>

<script>
import CommonPage from "@/components/echarts-part/stuff/CommonPage.vue";
import QueryView from "@/components/common/display/query-view/QueryView.vue";
import ReBModal from "@/components/echarts-part/CalendarShift/cells/stuffs/ReBModal.vue";
import MiniButton from "@/components/common/buttons/MiniButton.vue";
import '@vue-js-cron/light/dist/light.css';
import miniTableCheckedMixin from "@/mixin/em/common/stuffs/table/miniTableCheckedMixin";
import BtnSelect from "@/components/common/inputs/BtnSelect.vue";
import MiniInput from "@/components/common/inputs/MiniInput.vue";
import Vue from 'vue'
import CronLight from '@vue-js-cron/light';
import QgEntityPick from "@/components/qg/QgEntityPick.vue";
import QgFilterBuilder from "@/components/qg/QgFilterBuilder.vue";
import {listToMap, mapToList} from "@/plugins/configure-query-helper";

Vue.use(CronLight);
export default {
    name: "ExportFileTaskList",
    components: {QgFilterBuilder, MiniInput, QgEntityPick, BtnSelect, MiniButton, ReBModal, QueryView, CommonPage},
    mixins: [miniTableCheckedMixin],
    data() {
        return {
            saveCronLoading: false,
            currentRow: null,
            cron: '',
            error: '',

            requestMethods: ['GET', 'POST'],
            request: {
                method: 'GET',
                url: '',
                params: {},
                body: {},
            },
            jscFilter: {
                identifyCode: 'query-config',
            },
            pickedConfig: null,
            saveRequestLoading: false,

            configurationLoading: false,
            triggerLoading: false,
            serviceOptions: [],
        }
    },
    computed: {
        $_configCode() {
            return 'export_file_task';
        },
    },
    mounted() {
        this.getServiceOptions();
    },
    methods: {
        mapToList,
        listToMap,
        openCronModal(row) {
            this.currentRow = row;
            this.cron = row.taskCron;
            this.$refs.cronEdit.showModal();
        },
        saveCron() {
            if (this.currentRow) {
                this.saveCronLoading = true;
                this.$store.dispatch('api/post', {
                    url: `${process.env.VUE_APP_EM_ASSISTANT_URL}/exportTask/set/cron?id=${this.currentRow.id}&cron=${this.cron}`,
                    data: {}
                }).then(() => {
                    this.$message.success("Save success");
                    this.$refs.cronEdit.hide();
                    this.$refs.table.queryRows();
                }).finally(() => this.saveCronLoading = false);
            }
        },
        openRequestModal(row) {
            this.currentRow = row;
            let rc = row.requestConfig;
            if (rc) {
                this.request = JSON.parse(rc);
                this.request.url = row.requestUrl;
                let id = this._getQueryParam(this.request.url, 'id');
                if (id) {
                    this.configurationLoading = true;
                    this.$query({
                        key: 'jsc',
                        where: {
                            id: id
                        }
                    }).then(res => {
                        if (res.data) {
                            let row = res.data[0];
                            this.pickedConfig = row.configuration;
                        }
                    }).finally(() => this.configurationLoading = false);
                }
            } else {
                this.request = {
                    method: 'GET',
                    url: '',
                    params: {},
                    body: {},
                };
            }
            this.$refs.requestConfig.showModal();
        },
        jscRowSelect(row) {
            if (row.id) {
                this.pickedConfig = row.configuration;
                let host = process.env.VUE_APP_EM_GATEWAY_URL;
                for (let item of this.serviceOptions) {
                    if (item.name === row.moduleCode) {
                        if (item.value) {
                            host = item.value;
                        }
                        break;
                    }
                }
                this.$set(this.request, 'url', `${host}/${row.moduleCode}/qg/export/excel?id=${row.id}&locale=${this.$i18n.locale()}`);
                this.$set(this.request, 'method', 'POST');
            }
        },
        clearRequest() {
            this.pickedConfig = null;
            this.$set(this.request, 'url', '');
        },
        saveRequestConfig() {
            if (this.currentRow) {
                this.saveRequestLoading = true;
                this.$store.dispatch('api/post', {
                    url: `${process.env.VUE_APP_EM_ASSISTANT_URL}/exportTask/set/request?id=${this.currentRow.id}`,
                    data: this.request
                }).then(() => {
                    this.$message.success("Save success");
                    this.$refs.requestConfig.hide();
                    this.$refs.table.queryRows();
                }).finally(() => this.saveRequestLoading = false);
            }
        },

        execute() {
            if (this.$_checkedOne) {
                this.triggerLoading = true;
                this.$store.dispatch('api/post', {
                    url: `${process.env.VUE_APP_EM_ASSISTANT_URL}/exportTask/trigger?id=${this.checkedRow.id}`
                }).then(() => {
                    this.$message.success("Execute success");
                }).finally(() => this.triggerLoading = false);
            }
        },

        getServiceOptions() {
            this.$store.dispatch('dictionaryEnumStore/getDictOriginal', 'query_config_server')
                .then(res => {
                    this.serviceOptions = res;
                });
        },
    }
}
</script>

<style scoped>

</style>
